export const CUSTOMER_SIGN_IN_URL = `${process.env.baseUrl}/customer/account/loginPost?vue`;
export const CUSTOMER_LOG_OUT_URL = `${process.env.baseUrl}/customer/account/logout/?vue`;
export const CHECK_CUSTOMER_URL = `${process.env.baseUrl}/customer/data/`;
export const GET_MAGENTO_MESSAGE = `${process.env.baseUrl}/customer/messages/`;
